module.exports = __webpack_public_path__ + "img/duplicate.fc7045ab.svg";